// extracted by mini-css-extract-plugin
export default {"body":"your-career_body__GHrkM"};